import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

// Always add /api prefix to request URLs if not already present
api.interceptors.request.use((config) => {
  const base = config.baseURL || '';
  const url = config.url || '';
  // Add /api prefix if baseURL doesn't already end with /api
  if (typeof base === 'string' && !base.replace(/\/+$/, '').endsWith('/api')) {
    if (typeof url === 'string' && !url.startsWith('/api')) {
      config.url = '/api' + (url.startsWith('/') ? url : '/' + url);
    }
  }
  // If baseURL already includes "/api", don't double-prefix request URLs.
  if (typeof base === 'string' && base.replace(/\/+$/, '').endsWith('/api') && typeof url === 'string' && url.startsWith('/api/')) {
    config.url = url.replace(/^\/api/, '');
  }
  return config;
});

// automatic multipart handling: remove content-type if FormData
api.interceptors.request.use((config) => {
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }
  return config;
});

// Attach JWT token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('wd_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auto-logout on 401
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('wd_token');
      localStorage.removeItem('wd_user');
      window.location.href = '/admin/login';
    }
    return Promise.reject(err);
  }
);

export default api;
